<header>
  <div class="app-header">
    <div class="header-content">
      <div id="menu">
        <input type="checkbox" [(ngModel)]="menuOpen" (click)="showMenu()" />
        <div class="menu-bar menu-bar--top">
          <div class="menu-bar--inner"></div>
        </div>
        <div class="menu-bar menu-bar--middle">
          <div class="menu-bar--inner"></div>
        </div>
        <div class="menu-bar menu-bar--bottom">
          <div class="menu-bar--inner"></div>
        </div>
      </div>

      <div class="header-logo">
        <sl-icon icon="beacon" aria-hidden="false" aria-label="beacon logo" class="header-lu"></sl-icon>
        <p>Beacon</p>
      </div>
      <sl-theme-selector class="theme-selector mobile"></sl-theme-selector>
      <nav class="header-nav" [ngClass]="{'mobile-menu--open' : menuOpen}">
        <ul class="header-nav-items">
          <ng-container *ngFor="let menuItem of menu;">
            <li *ngIf="!menuItem.submenu && menuItem.hasPermission" class="app-links">

              <ng-template [ngIf]="menuItem.external" [ngIfElse]="topLevelRouterLink">
                <a class="menu-item" [href]="menuItem.path">
                  <sl-icon *ngIf="menuItem.icon" icon="{{menuItem.icon}}"></sl-icon>{{menuItem.linkText}}
                </a>
              </ng-template>

              <ng-template #topLevelRouterLink>
                <a class="menu-item" [routerLink]="menuItem.path" routerLinkActive="active-menu-item"
                  [queryParams]="menuItem.queryParams">
                  <sl-icon *ngIf="menuItem.icon" icon="{{menuItem.icon}}"></sl-icon>{{menuItem.linkText}}
                </a>
              </ng-template>

            </li>

            <li class="app-links desktop">
              <sl-menu *ngIf="menuItem.submenu && menuItem.hasPermission" name="New"
                [items]="menuItem.submenu"></sl-menu>
            </li>

          </ng-container>

          <li class="app-links desktop"><sl-theme-selector class="menu-item"></sl-theme-selector></li>

        </ul>

      </nav>

    </div>
  </div>

  <div class="menu-overlay" [ngClass]="{'active' : menuNewOpen}" (click)="showNewMenu()"></div>
  <a href="#" onclick="return false;" class="new-menu-btn" (click)="showNewMenu()"
    [ngClass]="{'active' : menuNewOpen}">+</a>
  <div class="new-menu" [ngClass]="{'new-menu--open' : menuNewOpen}">

    <ng-container *ngFor="let menuItem of menu;">
      <ng-container *ngIf="menuItem.linkText === 'New'">
        <ng-container *ngTemplateOutlet="submenu;context:{menuItem:menuItem}"></ng-container>
      </ng-container>
    </ng-container>
  </div>
</header>

<ng-template #submenu let-menuItem="menuItem">

  <ul *ngIf="menuItem.submenu && menuItem.hasPermission" class="">
    <ng-container *ngFor="let submenuItem of menuItem.submenu;">

      <li *ngIf="submenuItem.hasPermission" class="">

        <ng-template [ngIf]="!submenuItem.external" [ngIfElse]="subLevelRouterLink">
          <a class="sub-menu-item" [routerLink]="submenuItem.path">
            <sl-icon *ngIf="submenuItem.icon" icon="{{submenuItem.icon}}"></sl-icon>
            {{submenuItem.linkText}}
          </a>
        </ng-template>

        <ng-template #subLevelRouterLink>

          <a target="_blank" role="menuitem" class="sub-menu-item external-item"
            [href]="submenuItem.path">{{submenuItem.linkText}}</a>
        </ng-template>

      </li>
    </ng-container>
  </ul>

</ng-template>